import {
  GET_DOWNLOAD_HISTORY_REQUEST,
  GET_DOWNLOAD_HISTORY_SUCCESS,
  GET_DOWNLOAD_HISTORY_FAILURE,
  GET_DOWNLOAD_HISTORY_DETAIL_REQUEST,
  GET_DOWNLOAD_HISTORY_DETAIL_SUCCESS,
  GET_DOWNLOAD_HISTORY_DETAIL_FAILURE,
  GET_DOWNLOAD_HISTORY_OVERVIEW_REQUEST,
  GET_DOWNLOAD_HISTORY_OVERVIEW_SUCCESS,
  GET_DOWNLOAD_HISTORY_OVERVIEW_FAILURE,
} from '../../constants/ActionTypes'
import { DOWNLOAD_HISTORY_PER_PAGE, DOWNLOAD_HISTORY_DETAIL_PER_PAGE } from '../../constants/Constants';
import { DownloadHistoryApi } from '../api/DownloadHistoryApi';

/*** GET /executive_export_histories/summary （サマリー一覧） ***/
const getDownloadHistoryRequest = (overwrite) => ({
  type: GET_DOWNLOAD_HISTORY_REQUEST,
  payload: {
    overwrite: overwrite,
  }
});

const getDownloadHistorySuccess = (data, pageInfo, overwrite) => ({
  type: GET_DOWNLOAD_HISTORY_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
    overwrite: overwrite,
  }
});

const getDownloadHistoryFailure = (error) => ({
  type: GET_DOWNLOAD_HISTORY_FAILURE,
  payload: {
    error: error
  }
});

export function getDownloadHistory(data = { 'page': 1, 'per_page': DOWNLOAD_HISTORY_PER_PAGE }, overwrite = true) {
  return async (dispatch) => {
    let query = {
      ...data,
    }

    dispatch(getDownloadHistoryRequest(overwrite));

    DownloadHistoryApi.getDownloadHistorySummary(query, dispatch)
      .then((response) => {
        // サマリーはバックエンドで集約済み。ページネーションのラッパー（Laravel標準）から一覧とページ情報を取り出す。
        const { data: list, ...pageInfo } = response.data;
        dispatch(getDownloadHistorySuccess(
          list,
          pageInfo,
          overwrite
        ));
      })
      .catch((error) => {
        dispatch(getDownloadHistoryFailure(error.response));
      });
  };
}

/*** GET /executive_export_histories （明細） ***/
const getDownloadHistoryDetailRequest = () => ({
  type: GET_DOWNLOAD_HISTORY_DETAIL_REQUEST,
});

const getDownloadHistoryDetailSuccess = (data, pageInfo) => ({
  type: GET_DOWNLOAD_HISTORY_DETAIL_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
  }
});

const getDownloadHistoryDetailFailure = (error) => ({
  type: GET_DOWNLOAD_HISTORY_DETAIL_FAILURE,
  payload: {
    error: error
  }
});

/**
 * 指定した注文（instructed_at）の明細を取得する。
 * 明細APIに instructed_at の完全一致で絞り込ませ、対象注文の明細のみをページング取得する。
 *
 * @param {string} instructedAt 対象注文のダウンロード日時（Y-m-d H:i:s）
 * @param {number} ownershipUserId 所有ユーザーID
 * @param {number} page ページ番号
 * @param {number} perPage 1ページあたりの件数
 */
export function getDownloadHistoryDetail(instructedAt, ownershipUserId, page = 1, perPage = DOWNLOAD_HISTORY_DETAIL_PER_PAGE) {
  return async (dispatch) => {
    dispatch(getDownloadHistoryDetailRequest());

    let query = {
      ownership_user_id: ownershipUserId,
      instructed_at: instructedAt,
      page: page,
      per_page: perPage,
    };

    DownloadHistoryApi.getDownloadHistoryDetail(query, dispatch)
      .then((response) => {
        // Laravel標準のページネーションラッパーから明細一覧とページ情報を取り出す
        const { data: detail, ...pageInfo } = response.data;
        dispatch(getDownloadHistoryDetailSuccess(detail, pageInfo));
      })
      .catch((error) => {
        dispatch(getDownloadHistoryDetailFailure(error.response));
      });
  };
}

/*** GET /executive_export_histories/overview （概要: 注文数・ダウンロード件数） ***/
const getDownloadHistoryOverviewRequest = () => ({
  type: GET_DOWNLOAD_HISTORY_OVERVIEW_REQUEST,
});

const getDownloadHistoryOverviewSuccess = (overview) => ({
  type: GET_DOWNLOAD_HISTORY_OVERVIEW_SUCCESS,
  payload: {
    overview: overview,
  }
});

const getDownloadHistoryOverviewFailure = (error) => ({
  type: GET_DOWNLOAD_HISTORY_OVERVIEW_FAILURE,
  payload: {
    error: error
  }
});

/**
 * 選択中の対象(is_own)・期間(instructed_at)のダウンロード履歴の概要を取得する。
 *
 * @param {object} data is_own / instructed_at_from / instructed_at_to を含むクエリ
 */
export function getDownloadHistoryOverview(data = {}) {
  return async (dispatch) => {
    dispatch(getDownloadHistoryOverviewRequest());

    DownloadHistoryApi.getDownloadHistoryOverview({ ...data }, dispatch)
      .then((response) => {
        dispatch(getDownloadHistoryOverviewSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getDownloadHistoryOverviewFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/DownloadHistory.js